import { AUAnalyticsUtils } from '@assertiva/assertiva-ui';

export const sendInternalAnalytics = (event: any) =>
  AUAnalyticsUtils.sendAnalytics(event, true, true);

export const sendAnalytics = (event: any) =>
  AUAnalyticsUtils.sendAnalytics(event);
